import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

interface LoadingBuySellInfoProps {}

const LoadingItem = () => {
  return (
    <VStack
      borderRadius={BoxRadius.sm}
      bg={Color.background}
      p={Spacing['inline.xxxs']}
      space={Spacing['inline.quarck']}
      mb={Spacing['stack.xxxs']}>
      <HStack alignItems="center">
        <HStack
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          p={Spacing['inline.nano']}>
          <Skeleton
            w="30px"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="70px"
            h="40px"
            borderRadius="full"
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack
          direction="row-reverse"
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          p={Spacing['inline.nano']}>
          <Skeleton
            w="30px"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            w="70px"
            h="40px"
            borderRadius="full"
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </HStack>
    </VStack>
  );
};

export const LoadingBuySellInfo: React.FC<LoadingBuySellInfoProps> = () => {
  const layout = Array.from({ length: 5 }).map((_, index) => (
    <LoadingItem key={index.toString()} />
  ));

  return layout;
};
